import { useFetchPageV2 } from "~/core/composables/useFetchPageV2";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.interface";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_ILIKE,
  OPERATOR_RSQL_IN,
} from "~/core/models/filters";
import OperationManagerService from "~/core/services/operationManager.service";
import filtersUtils from "~/core/utils/filters.utils";

export function useOperationManager({
  searchMode,
  useQueryParametersForPagination,
  organizationCode,
}: UseFetchParameters) {
  const service = OperationManagerService.getOperations.bind(
    OperationManagerService,
  );

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.OPERATION_CAMPAIGN_UID,
      {
        key: "campaignUid",
        operator: OPERATOR_RSQL_IN,
        value: [],
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.DTWIN_UID,
      {
        key: "deviceTwinUid",
        operator: OPERATOR_RSQL_IN,
        value: "",
      },
    ],
    [
      Filters.DTWIN_OPERATION_MODEL_TYPE,
      {
        key: "type",
        operator: OPERATOR_RSQL_IN,
        value: "",
      },
    ],
    [
      Filters.DTWIN_OPERATION_SERVICE_ORIGIN,
      {
        key: "serviceOrigin",
        operator: OPERATOR_RSQL_IN,
        value: "",
      },
    ],
    [
      Filters.DTWINS_CONFIGURATION_VERSIONS,
      {
        key: [
          "customInputParameters.selfSupportingVersion",
          "customInputParameters.globalVersion",
          "specificVersion",
        ],
        operator: OPERATOR_RSQL_ILIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.SECTORS,
      {
        key: "sectorCode",
        operator: OPERATOR_RSQL_IN,
        value: "",
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPageV2({
    service,
    searchParams,
    sort,
    useQueryParametersForPagination,
    organizationCode,
  });

  return {
    isLoading,
    error,
    results,
    filters,
    setFilter,
    fetchData,
    onSortChange,
    search,
    onSearch,
    sort,
  };
}
